export default __webpack_public_path__ + "img/34a081316a2ba25f6360628c0e98e3a1.png";